import React from 'react';
import { AutocompleteArrayInput, ReferenceArrayInput } from 'react-admin';
import { filterToQuery } from '../../../utils';
import { getChainId } from '../../../lib';

const FormCitys: React.FC<any> = ({ formData }) => (
  <>
    <ReferenceArrayInput
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      source="cityIds"
      reference="cities"
      filter={{ chainId: getChainId() }}
    >
      <AutocompleteArrayInput
        style={{ minWidth: 260 }}
        label="Cidades"
        optionText="name"
        filterToQuery={filterToQuery}
      />
    </ReferenceArrayInput>
  </>
);

export default FormCitys;